import { z } from 'zod';
/*developer: Nithin
    date : 2024-06-19
    changes : Replaced Telecaller With Staff */
    
const roleEnum = z.enum(
  ['owner', 'admin', 'designer', 'senior_designer', 'installation_team', 'accountant', 'store_incharge', 'client_coordinator', 'designer', 'sales_executive', 'field_marketing', 'social_media', 'store_incharge'],
  { errorMap: () => ({ message: 'Please select a valid role' }) }
);

const TRADES = [   ];

/** 8–10 chars, at least one uppercase (A–Z) and one special (non letter/digit). */
export const teamMemberPasswordSchema = z
  .string()
  .trim()
  .min(8, 'Password must be at least 8 characters')
  .max(10, 'Password must be at most 10 characters')
  .regex(/[A-Z]/, 'Include at least one uppercase letter (A–Z)')
  .regex(/[^A-Za-z0-9]/, 'Include at least one special character (e.g. !@#$%)');

const normalizePhoneDigits = (value) =>
  String(value ?? '')
    .trim()
    .replace(/[^\d]/g, ''); // allow spaces, dashes, etc. in UI input

const normalizeJoiningDate = (value) => {
  const s = String(value ?? '').trim();
  if (!s) return '';
  // Accept both `YYYY-MM-DD` (native date input) and `DD-MM-YYYY` (typed/pasted).
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const m = s.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  return s;
};

const baseFields = {
  firstName: z.string().min(3, 'First name must be at least 3 characters'),
  lastName: z.string().optional().or(z.literal('')),
  phone: z.string().length(10, 'Phone number must be exactly 10 digits').regex(/^\d+$/, 'Phone number must contain only digits'),
  email: z.union([z.literal(''), z.string().email('Please enter a valid email address')]).optional(),
  employeeId: z.string().min(1, 'Employee ID is required'),
  role: roleEnum,
  installationTrade: z.string().optional().or(z.literal('')),
  joiningDate: z.string().min(1, 'Joining date is required'),
  workLocation: z.string().min(1, 'Work location is required'),
  loginId: z.string().optional().or(z.literal('')),
  notes: z.string().optional().or(z.literal(''))
};

const requireTradeForInstallationMember = (data, ctx) => {
  if (data.role !== 'installation_team') {
    if (!data.email || data.email.trim() === '') {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Please enter a valid email address',
        path: ['email']
      });
    }
    return;
  }
  const t = data.installationTrade;
  if (!t || !TRADES.includes(t)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Select installation type: Carpenter, Electrician, Painter, or Plumber',
      path: ['installationTrade']
    });
  }
};

export const employeeCreateSchema = z
  .object({
    ...baseFields,
    password: z.union([z.literal(''), teamMemberPasswordSchema]).optional()
  })
  .superRefine((data, ctx) => {
    requireTradeForInstallationMember(data, ctx);
    if (data.role !== 'installation_team') {
      if (!data.password || data.password.trim() === '') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Password is required',
          path: ['password']
        });
      }
    }
  });

export const employeeUpdateSchema = z
  .object({
    ...baseFields,
    password: z.union([z.literal(''), teamMemberPasswordSchema]).optional()
  })
  .superRefine(requireTradeForInstallationMember);
